export const ServerPath = 'http://meditoc.net:7412';
//export const ServerPath = 'http://127.0.0.1:7412';
export const loginUrl = `${ServerPath}/login`;
export const RegisterUrl = `${ServerPath}/register`;
export const UserInfoUrl = `${ServerPath}/user/info`;
export const AssetsLogUrl = `${ServerPath}/user/asset_log/list`;

